import React from 'react';

const RecordInfoContext = React.createContext();
export default RecordInfoContext;
